import Fetch from "./fetch";

export class ProfileNetwork {

  // Детали пользователя для профиля
  static async getProfile() {
    return await Fetch.get('/api/profile/detail');
  }

  // Список устройств пользователя
  static async getProfileDevice() {
    return await Fetch.get('/api/profile/device');
  }

  // Завершение сеанса устройств
  static async deleteProfileDevice(token_id, params) {
    return await Fetch.post(`/api/profile/device/${token_id}`, JSON.stringify(params));
  }

  // Список документов пользователя
  static async getProfileDocuments(params) {
    return await Fetch.get('/api/profile/documents', params);
  }

  // Создать ИИ-отчет по документу
  static async postCreateAiReport(params) {
    return await Fetch.post('/api/profile/ai_report', JSON.stringify(params));
  }
  
  // Создать обращение в поддержку
  static async postSupportMessage(params) {
    return await Fetch.post('/api/profile/support', JSON.stringify(params));
  }

  // Изменение профиля юзера
  static async postProfileUpdate(params) {
    return await Fetch.post('/api/profile/update', JSON.stringify(params));
  }
}
